export default "__VITE_ASSET__DaDLuWU8__"